import styled from "@emotion/styled";
import { Heading as CWHeading } from "@polestar/component-warehouse-react";

const Heading = styled(CWHeading)`
  white-space: pre-line;
`;

export default Heading;
